/* eslint-disable no-unused-vars */
import React, { useEffect, lazy, Suspense } from "react";
import { useState } from "react";
import candidateTabsviewStyle from "../Candidate/CandidateTabsview.module.scss";
import JobRolesTable from "../../AdminDetails/ConfigarationTablesCrud/JobRoleDetails/jobRolesTable";
import { IoPersonAddSharp } from "react-icons/io5";
import SkillAddTable from "../../AdminDetails/ConfigarationTablesCrud/KeySkillsDetails/SkillDetailsTable";
import TargetAnalyticsTable from "../../AdminDetails/ConfigarationTablesCrud/Targetanalytics/TargetAnalyticsTable";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { MdOutlineDashboard } from "react-icons/md";
import RetentionOnInvest from "../../ROI/Roi";

const JobLead = lazy(() => import("../../Employer/jobLead/JobLead"));
const JobsTable = lazy(() => import("../../Jobs/JobsAll/JobsTable"));

function SuperAdminTableView() {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabValue) => {
    setActiveTab(tabValue);
    window.location.hash = tabValue;
  };

  useEffect(() => {
    const hashValue = window.location.hash.substring(1); // Exclude the '#' symbol

    // Now 'hashValue' contains the value of the hash fragment

    if (hashValue) {
      switch (hashValue) {
        case "addUser":
          handleTabClick("addUser");
          break;
        case "addRole":
          handleTabClick("addRole");
          break;
        case "addSkill":
          handleTabClick("addSkill");
          break;
        case "adminsTarget":
          handleTabClick("adminsTarget");
          break;
        case "Admin Joining":
          handleTabClick("Admin Joining");
          break;

        default:
          handleTabClick("addRole");
          break;
      }
    } else {
      handleTabClick("addRole");
    }
  }, []);
  return (
    <div>
      <div className={`tab-buttons ${candidateTabsviewStyle.tab_buttons}`}>
        <div className={`d-flex ${candidateTabsviewStyle.tab_hr}`}>
          {/* <div
            onClick={() => handleTabClick("addUser")}
            className={` ${
              activeTab === "addUser"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            } `}
          >
            <IoPersonAddSharp /> Add User
          </div> */}
          <div
            onClick={() => handleTabClick("addRole")}
            className={` ${
              activeTab === "addRole"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            <IoPersonAddSharp /> Job Role
          </div>
          <div
            onClick={() => handleTabClick("addSkill")}
            className={` ${
              activeTab === "addSkill"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            <IoPersonAddSharp /> Key Skill
          </div>
          <div
            onClick={() => handleTabClick("adminsTarget")}
            className={` ${
              activeTab === "adminsTarget"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            <RiMoneyDollarCircleFill className="fs-5" /> Recruitment Target
          </div>
            <div
              onClick={() => handleTabClick("Admin Joining")}
              className={` ${
                activeTab === "Admin Joining"
                  ? candidateTabsviewStyle.activetag
                  : candidateTabsviewStyle.unactivetag
              } `}
            >
              <MdOutlineDashboard /> ROI
            </div>
        </div>
        <hr style={{ borderTop: "10px solid #ccc" }} />
      </div>

      <div className={`tab-content ${candidateTabsviewStyle.tab_content}`}>
        {activeTab === "addRole" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <JobRolesTable />
            </Suspense>
          </p>
        )}
        {activeTab === "addSkill" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <SkillAddTable />
            </Suspense>
          </p>
        )}
        {activeTab === "adminsTarget" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <TargetAnalyticsTable />
            </Suspense>
          </p>
        )}
         {activeTab === "Admin Joining" && (
                  <p>
                    <Suspense fallback={<div>Loading...</div>}>
                      {/* <AdminTable /> */}
                      <RetentionOnInvest />
                    </Suspense>
                  </p>
                )}
      </div>
    </div>
  );
}

export default SuperAdminTableView;
